<template>
  <div>
    <DatePickerInput
      :id="'rates-date'"
      :value="selectedDate"
      :label-text="$t('Select day')"
      :max="maxDate"
      :min="minDate"
      :error="noCurrencyError"
      :error-message="$t('No currency rates available for this date')"
      @input="handleDateChanging"
    />
  </div>
</template>

<script>
  import DatePickerInput from '@/components/ui/DatePickerInput';
  import { mapMutations, mapState } from 'vuex';
  import { currentDate } from '@/utils/date/current-date';
  import factory from '@/utils/api/factory';

  export default {
    name: 'RatesUpdate',
    components: { DatePickerInput },
    data() {
      return {
        maxDate: null,
        minDate: null,
        noCurrencyError: false,
      };
    },
    async created() {
      try {
        let { data } = await factory('currency_rates/boundaries').index();
        this.maxDate = data.max_date;
        this.minDate = data.min_date;
      } catch (e) {
        console.error(e);
      }
    },
    computed: mapState({
      selectedDate: (state) => state.confirmModal?.context?.data?.date || currentDate(),
      projectId: (state) => state.confirmModal?.context?.data?.projectId,
    }),
    methods: {
      ...mapMutations('confirmModal', ['changeData']),
      async handleDateChanging(date) {
        this.noCurrencyError = false;
        try {
          let { data } = await factory('projects').indexInPath(`${this.projectId}/rates`, {
            date,
          });
          this.changeData({
            key: 'date',
            value: date,
          });
          this.changeData({
            key: 'rates',
            value: data.currency_rates,
          });
        } catch (e) {
          if (e.response?.status === 404) {
            this.noCurrencyError = true;
          } else {
            console.error(e);
          }
        }
      },
    },
  };
</script>
